module.exports = __webpack_public_path__ + "static/media/highway-1-road-trip-scotts-creek-san-francisco-santa-cruz-via-magazine.20f7e379.jpg";